export default [
  {
    id: 1,
    name: 'Produtos',
    nivel: 0,
    seq: 1,
    parent: 0,
    active: false
  },
  {
    id: 2,
    name: 'Cadastro',
    nivel: 1,
    seq: 2,
    parent: 1,
    active: false
  },
  {
    id: 3,
    name: 'Consulta',
    nivel: 1,
    seq: 3,
    parent: 1,
    active: false
  },
  {
    id: 4,
    name: 'Atualização',
    nivel: 1,
    seq: 4,
    parent: 1,
    active: false
  },
  {
    id: 5,
    name: 'Deletar',
    nivel: 1,
    seq: 5,
    parent: 1,
    active: false
  },
  {
    id: 6,
    name: 'Clientes',
    nivel: 0,
    seq: 6,
    parent: 0,
    active: false
  },
  {
    id: 7,
    name: 'Cadastro',
    nivel: 1,
    seq: 7,
    parent: 6,
    active: false
  },
  {
    id: 8,
    name: 'Consulta',
    nivel: 1,
    seq: 8,
    parent: 6,
    active: false
  },
  {
    id: 9,
    name: 'Atualização',
    nivel: 1,
    seq: 9,
    parent: 6,
    active: false
  },
  {
    id: 10,
    name: 'Deletar',
    nivel: 1,
    seq: 10,
    parent: 6,
    active: false
  },
  {
    id: 11,
    name: 'Pedidos',
    nivel: 0,
    seq: 11,
    parent: 0,
    active: false
  },
  {
    id: 12,
    name: 'Cadastro',
    nivel: 1,
    seq: 12,
    parent: 11,
    active: false
  },
  {
    id: 13,
    name: 'Consulta',
    nivel: 1,
    seq: 13,
    parent: 11,
    active: false
  },
  {
    id: 14,
    name: 'Atualização',
    nivel: 1,
    seq: 14,
    parent: 11,
    active: false
  },
  {
    id: 15,
    name: 'Deletar',
    nivel: 1,
    seq: 15,
    parent: 11,
    active: false
  },
  {
    id: 16,
    name: 'Usuários',
    nivel: 0,
    seq: 16,
    parent: 0,
    active: false
  },
  {
    id: 17,
    name: 'Cadastro',
    nivel: 1,
    seq: 17,
    parent: 16,
    active: false
  },
  {
    id: 18,
    name: 'Consulta',
    nivel: 1,
    seq: 18,
    parent: 16,
    active: false
  },
  {
    id: 19,
    name: 'Atualização',
    nivel: 1,
    seq: 19,
    parent: 16,
    active: false
  },
  {
    id: 20,
    name: 'Deletar',
    nivel: 1,
    seq: 20,
    parent: 16,
    active: false
  },
  {
    id: 21,
    name: 'Cupons',
    nivel: 0,
    seq: 21,
    parent: 0,
    active: false
  },
  {
    id: 22,
    name: 'Cadastro',
    nivel: 1,
    seq: 22,
    parent: 21,
    active: false
  },
  {
    id: 23,
    name: 'Consulta',
    nivel: 1,
    seq: 23,
    parent: 21,
    active: false
  },
  {
    id: 24,
    name: 'Atualização',
    nivel: 1,
    seq: 24,
    parent: 21,
    active: false
  },
  {
    id: 25,
    name: 'Deletar',
    nivel: 1,
    seq: 25,
    parent: 21,
    active: false
  },
  {
    id: 26,
    name: 'Preferências',
    nivel: 0,
    seq: 26,
    parent: 0,
    active: false
  },
  {
    id: 27,
    name: 'Formas de pagamento',
    nivel: 0,
    seq: 27,
    parent: 0,
    active: false
  },
  {
    id: 28,
    name: 'Cadastro',
    nivel: 1,
    seq: 28,
    parent: 27,
    active: false
  },
  {
    id: 29,
    name: 'Consulta',
    nivel: 1,
    seq: 29,
    parent: 27,
    active: false
  },
  {
    id: 30,
    name: 'Atualização',
    nivel: 1,
    seq: 30,
    parent: 27,
    active: false
  },
  {
    id: 31,
    name: 'Deletar',
    nivel: 1,
    seq: 31,
    parent: 27,
    active: false
  }
]
